<template>
  <div class="body-bg-white">
    <SPreloader />
    <div
      class="main-header main-header-fullwidth main-header-has-header-standard mb-0"
    >
      <SLandingTopBar />
      <SLandingAboutContent />
    </div>
    <SubHeaderCategories :categories="categories" pageName="Landing Page" class="landing-page-categories"/>
    <div class="container mt-3">
      <div class="row">
        <div
          class="col col-xl-12 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12"
          data-cy="divSearchResults"
        >
          <SFilterBar
            class="ml-2"
            @button="makeSearch"
            @clearFilter="clearFilter"
            @removeFilter="removeFilter"
            :options="options"
            :choice="choice"
            :optionsType="optionsType"
            :optionsPrivacy="optionsPrivacy"
            :optionsCategory="optionsCategory"
            :optionsCondition="optionsCondition"
            :startWith="startOption"
            :selectedFilters="selectedFilters"
            :startCategory="startCategory"
            ref="sfilter"
          />
          <SLazyContent
            v-if="isSearching"
            :numberOfItems="3"
            data-cy="fetchingResults"
          />
          <div id="search-item-gallery" class="md-layout md-gutter">
            <div
              v-for="(result, index) in filteredResults"
              class="md-layout-item"
              :key="index"
            >
              <SNewItemMaterial
                :item="result"
                :class="{
                  'item-unavailable':
                    result.status === itemStatus.RECEIVED ||
                    result.status === itemStatus.SENT,
                }"
              />
            </div>
            <div
              v-if="!filteredResults.length"
              class="ui-block px-4 py-5 text-center"
              data-cy="fetchingContentLandingPage"
            >
              <span>
                <span
                  >Sorry, no items matched the filter options.
                  <md-icon>sentiment_very_dissatisfied</md-icon></span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterUnlogged />
    <a class="back-to-top" href="#" ref="goTop" v-if="isBottom">
      <img src="svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
    <Modal
      buttonName="OK"
      id="facebook-error"
      title="Facebook error"
      @button="closeModal('facebook-error')"
      ref="fbError"
    >
      <h5>
        Something went wrong when trying to validate your Facebook account.
      </h5>
    </Modal>
    <Modal
      id="login-redirect-modal"
      title="Authentication required"
      ref="modal"
      buttonName="LOG IN"
      buttonRegisterName="REGISTER"
      @button="confirmRedirect"
      @register="registerRedirect"
      :materialButton="true"
    >
      <h5 class="login-text">Please log in or register to continue</h5>
    </Modal>
    <CookiesAndPrivacy
      v-if="!storageCookies"
      @cookies-privacy="accept"
      :class="[{ 'safari-space': showSafariWarning }]"
    />
    <SafariWarning
      ref="safariWarning"
      @safari-warning="showSafariWarning = false"
    />
  </div>
</template>

<script>
import SPreloader from "@/components/organisms/SPreloader.vue";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SubHeaderCategories from "@/material-components/molecules/SubHeaderCategories.vue";
import SLandingAboutContent from "@/material-components/molecules/SLandingAboutContent.vue";
import FooterUnlogged from "@/templates/FooterUnlogged";
import Modal from "@/components/atoms/Modal.vue";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import ItemHelper from "@/mixins/ItemHelper";
import { mapGetters } from "vuex";
import SafariWarning from "@/material-components/molecules/SafariWarning.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
import SFilterBar from "@/components/molecules/SFilterBar";
import SLazyContent from "@/material-components/organisms/SLazyContent";
import item_status from "@/enum/item-status";
import UserHelper from "@/mixins/UserHelper.vue";

export default {
  name: "LandingPage",
  mixins: [ItemHelper, UserHelper],
  components: {
    SPreloader,
    SLandingTopBar,
    FooterUnlogged,
    Modal,
    CookiesAndPrivacy,
    SafariWarning,
    SubHeaderCategories,
    SLandingAboutContent,
    SNewItemMaterial,
    SFilterBar,
    SLazyContent,
  },
  data() {
    return {
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
      ip: null,
      isBottom: false,
      landingPageItems: [],
      redirectTo: null,
      canRedirect: false,
      showSafariWarning: false,
      prevRoute: null,
      isSearching: false,
      itemStatus: item_status,
      filter: {
        options: [],
        itemType: [],
        itemCondition: [],
        privacy: [],
        itemCategory: [],
      },
      selectedItemChat: null,
      warning: null,
      warningTitle: null,
      startOption: [],
      startCategory: [],
      options: [{ label: "Item", value: "item", dataCy: "itemOption" }],
      choice: {
        options: [],
        itemType: [],
        itemCondition: [],
        privacy: [],
        itemCategory: [],
      },
      optionsType: [
        { value: 1, label: "Give", dataCy: "giveTrade" },
        { value: 2, label: "Receive", dataCy: "receiveTrade" },
        { value: 3, label: "Lend", dataCy: "lendTrade" },
        { value: 4, label: "Borrow", dataCy: "borrowTrade" },
      ],
      optionsPrivacy: [
        { value: 1, label: "Public", dataCy: "publicPrivacy" },
        { value: 2, label: "Private", dataCy: "privatePrivacy" },
      ],
      optionsCondition: [
        { value: 1, label: "New", dataCy: "newCondition" },
        { value: 2, label: "Like New", dataCy: "likeNewCondition" },
        { value: 3, label: "Used", dataCy: "usedCondition" },
        { value: 4, label: "Worn", dataCy: "wornCondition" },
      ],
      optionsCategory: [
        { value: 8, label: "Books", icon: "book", dataCy: "bookCategory" },
        {
          value: 5,
          label: "Auto",
          icon: "directions_car",
          dataCy: "autoCategory",
        },
        {
          value: 3,
          label: "Clothing",
          icon: "checkroom",
          dataCy: "clothingCategory",
        },
        {
          value: 2,
          label: "Electronics",
          icon: "phone_android",
          dataCy: "electronicCategory",
        },
        {
          value: 9,
          label: "Family",
          icon: "child_friendly",
          dataCy: "familyCategory",
        },
        {
          value: 10,
          label: "Games",
          icon: "sports_esports",
          dataCy: "gamesCategory",
        },
        {
          value: 1,
          label: "Household",
          icon: "maps_home_work",
          dataCy: "householdCategory",
        },
        {
          value: 4,
          label: "Music",
          icon: "library_music",
          dataCy: "musicCategory",
        },
        {
          value: 11,
          label: "Sports",
          icon: "sports_football",
          dataCy: "sportsCategory",
        },
        {
          value: 12,
          label: "Tools",
          icon: "build",
          dataCy: "toolsCategory"
        },
        {
          value: 6,
          label: "Video",
          icon: "duo",
          dataCy: "videoCategory"
        },
        {
          value: 7,
          label: "Other",
          icon: "more_horiz",
          dataCy: "otherCategory",
        },
      ],
      categories: [
        {
          name: "free",
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "book",
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "auto",
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "clothing",
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "electronic",
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "family",
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "games",
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "houseHold",
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "music",
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "sports",
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "tools",
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "video",
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "other",
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
    }),
    selectedFilters() {
      let filters = [];
      this.options.forEach((filter) => {
        if (this.choice.options.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsCategory.forEach((filter) => {
        if (
          this.choice.itemCategory.includes(filter.value) &&
          filter.value !== ""
        )
          filters.push(filter);
      });
      this.optionsCondition.forEach((filter) => {
        if (
          this.choice.itemCondition.includes(filter.value) &&
          filter.value !== ""
        )
          filters.push(filter);
      });
      this.optionsType.forEach((filter) => {
        if (this.choice.itemType.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsPrivacy.forEach((filter) => {
        if (this.choice.privacy.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      return filters;
    },
    filteredResults() {
      let arr = this.landingPageItems.map((item) => {
        return {
          ...item,
        };
      });
      if (
        this.filter.options.length === 0 ||
        this.filter.options.includes("")
      ) {
        return arr;
      }
      if (this.filter.itemType.length !== 0) {
        arr = arr.filter((item) => {
          return this.filter.itemType.includes(item.type);
        });
      }
      if (this.filter.itemCategory.length !== 0) {
        arr = arr.filter((item) => {
          return this.filter.itemCategory.includes(item.category);
        });
      }
      if (this.filter.itemCondition.length !== 0) {
        arr = arr.filter((item) => {
          return this.filter.itemCondition.includes(item.condition);
        });
      }
      return arr;
    },
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
  watch: {
    isBottom(newValue) {
      if (typeof newValue === "boolean") {
        this.commitScrollStatus({ isBottom: newValue });
      }
    },
  },
  mounted() {
    this.checkScrollBottom();
    $("html,body").animate({
      scrollTop: 0,
    });

    if (this.$route.query.fbError) {
      $("#facebook-error").modal("show");
    }

    this.deleteLastInteractionTime();
    this.getRandom();
    if (this.isSafari() && this.showSafariWarning) {
      console.log(this.$refs.safariWarning);
      this.$refs.safariWarning.show();
    }

    if (
      this.prevRoute.name === "SItemDetailFromLandingPage" ||
      this.prevRoute.name === "SSearchResultFromLandingPage"
    ) {
      this.$router.go();
    }
  },
  methods: {
    isSafari() {
      if (window.navigator.vendor !== "Google Inc.") {
        if (!window.navigator.userAgent.match("CriOS")) {
          if (navigator.userAgent.indexOf("Safari") !== -1) {
            this.showSafariWarning = true;
            return true;
          }
        }
      }

      return false;
    },
    accept(a) {
      this.cookiesPrivacy = a;
    },
    makeSearch(value) {
      this.filter = value;
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal("hide");
      this.$refs.fbError.closeModal();
    },
    deleteLastInteractionTime() {
      localStorage.removeItem("last_interaction");
    },
    activateRegistrationForm() {
      this.$refs.loginRegistrationForm.$refs.register.click();
    },
    checkScrollBottom() {
      window.onscroll = () => {
        if (window.pageYOffset > 25) {
          this.isBottom = true;
        } else {
          this.isBottom = false;
        }
      };
    },
    async getRandom() {
      await this.fetchRandomItems();
      this.landingPageItems = this.randomItems.result;
    },
    confirmRedirect() {
      this.$refs.modal.closeModal();
      this.$router.push("/login")
    },
    registerRedirect(){
      this.$refs.modal.closeModal();
      this.$router.push("/signup")
    },
    saveOption(value) {
      this.dontShowModalAgain = value;
    },
    clearFilter() {
      this.choice = {
        options: [],
        itemType: [],
        itemCondition: [],
        privacy: [],
        itemCategory: [],
      };
    },
    removeFilter(removed) {
      if (this.options.includes(removed)) {
        this.choice.options = this.choice.options.filter((filter) => {
          return filter !== removed.value;
        });
        if (removed.value === "item") {
          this.choice.itemType = [];
          this.choice.itemCondition = [];
          this.choice.itemCategory = [];
        }
        if (removed.value === "group") {
          this.choice.privacy = [];
        }
      } else if (this.optionsType.includes(removed)) {
        this.choice.itemType = this.choice.itemType.filter((filter) => {
          return filter !== removed.value;
        });
      } else if (this.optionsCondition.includes(removed)) {
        this.choice.itemCondition = this.choice.itemCondition.filter(
          (filter) => {
            return filter !== removed.value;
          }
        );
      } else if (this.optionsPrivacy.includes(removed)) {
        this.choice.privacy = this.choice.privacy.filter((filter) => {
          return filter !== removed.value;
        });
      } else {
        this.choice.itemCategory = this.choice.itemCategory.filter((filter) => {
          return filter !== removed.value;
        });
      }
    },
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, _, next) {
    if (
      this.isUserAuthenticated ||
      this.canRedirect ||
      to.path === "/" ||
      to.name === "loginRedirect" ||
      to.name === "SItemDetailFromLandingPage"
    ) {
      next();
    } else {
      if (
        to.path !== "/login" &&
        to.name !== "SSearchResultFromLandingPage" &&
        to.path !== "/signup" &&
        to.path !== "/landing-help" &&
        to.path !== "/contact-us" &&
        to.path !== "/about-us" &&
        to.name !== "SItemDetailFromLandingPage" &&
        to.path !== "/garage-sales"
      ) {
        this.redirectTo = to.fullPath;
        $("#login-redirect-modal").modal("show");
      } else {
        next();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.row{
  margin-top: -1.3rem
}
.subheader {
  position: relative;
  top: unset;
  margin-top: -4em;

}
.main-header {
  padding: 0;
}
.md-layout-item {
  margin: 0 8px 16px !important;
  max-width: 576px;
  padding: 0 !important;
}
.spacer {
  margin-top: 7rem;
}
.login-text{
  color: rgba(0, 0, 0, 0.6) !important
}

@media screen and (max-width: 1271px) {
  .row{
    margin-top: -1.8rem
  }
  .spacer {
    margin-top: 10rem;
  }
  .subheader {
    margin-top: -4em;
  }
}
.text-center {
  display: flex;
  width: 100%;
  justify-content: center;
}

</style>

<style lang="scss">
@media screen and (max-width: 1024px) {
  .safari-space .button-fixed {
    bottom: 230px;
  }
  .subheader {
    margin-top: 0em !important;
  }

}

@media screen and (min-width: 768px) {
  .safari-space .button-fixed {
    bottom: 230px;
  }
}
.md-list-item-content > .md-checkbox:first-child,
.md-list-item-content > .md-radio:first-child {
  margin-right: 0 !important;
}
</style>
